import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { UserAccountMapped } from '@tassat/fred-extended-definitions';
import React from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

interface UserNameCellRendererProps{
    data: UserAccountMapped;
}

const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: { height: '100%' },
    userName: {
        fontSize: '1rem',
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        fontWeight: 'bold'
    },
    userEmail: {
        fontSize: '.75rem',
        color: theme?.app?.applicationColors.fontColor ||
            '#202020'
    }
}));

export const UserNameEmailCellRenderer = (props: UserNameCellRendererProps) => {
    const { data } = props;

    const classes = muiStyles(props);
    const user = data && data.user;

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            justifyContent='space-around'
            spacing={0}
            wrap='nowrap'
        >
            <Typography
                className={classes.userName}
                variant='h5'
            >{`${user.FirstName} ${user.LastName}`}
            </Typography>
            <Typography
                className={classes.userEmail}
                variant='body1'
            >{user.Email}
            </Typography>
        </Grid>
    );
};

export default UserNameEmailCellRenderer;